import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Routes, Route, Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import CoderProfile from './views/CoderProfilePage';
import CoderDashboardPage from './views/CoderDashboardPage';
import ClientProposalListPage from './views/ClientProposalListPage';
import ClientViewProposalPage from './views/ClientViewProposalPage';
import ClientHomePage from './views/ClientHomePage';
import ForgotPassword, { PasswordReset, SetNewPassword } from './components/ForgotPassword';
import AuthLayout from './components/Layout/AuthLayout';
import CoderHomePage from './views/CoderHomePage';
import CoderProfilePage from './views/CoderProfilePage';
import CoderApplyProposalPage from './views/CoderApplyProposalPage';
//Admin
import AdminLoginPage from './views/AdminLoginPage';
import { Modal, SpinnerLoader } from './components/Common';
import AdminManagePage from './views/AdminManageClientPage';
import AllJobsPage from './views/CoderAllJobsPage';
import RecommendedJobsPage from './views/CoderRecommendedJobs';
import OurTeamPage from './views/OurTeamPage';
import ContactUsPage from './views/ContactUsPage';
import CareerHomePage from './views/CareerHomePage';
import TestimonialPage from './views/TestimonialPage';
import FAQPage from './views/FAQHomePage';
import TermsAndConditionPage from './views/TermsAndCondition';
import ClientDashboardPage from './views/ClientDashboardPage';
import PolicyHomePage from './views/PolicyPage';
import SuccessManagerPage from './views/SuccessManagerPage';
import TexAndInitialFeePage from './views/TexAndInitialtionFee';
import { decryptedData } from './helper/utils';
import ConsultUspage from './views/ConsultUsPage';
import { LazyLoad } from './components/Shared/LazyLoad';
import AdminJobPage from './views/AdminJobPage';
import AdminDisputePage from './views/AdminDisputePage';
import SuccessPage from './components/Profile/SuccessConfirm';
import ClientRegistration from './components/Register/Client';
import CoderRegistration from './components/Register/Coder';
import Cookies from 'js-cookie';

const CoderProfileDetails = lazy(
  () => import('./components/ClientDashboard/components/CoderProfile')
);
const CoderList = lazy(() => import('./components/CoderList'));
const PageNotFound = lazy(() => import('./components/ErrorBoundary/PageNotFound'));
const ClientJobDetail = lazy(() => import('./components/Job/client'));
const JobAwarded = lazy(() => import('./components/JobAwarded'));
const JobDetails = lazy(() => import('./components/ClientDashboard/components/JobDetails'));
const PayNow = lazy(() => import('./components/ClientDashboard/components/PayNow'));
const CoderDetails = lazy(() => import('./components/CoderDetails'));
const ClientProfile = lazy(() => import('./components/Profile/Client'));
const TransactionHistory = lazy(() => import('./components/Reports/TransactionHistory'));
const TimeSheet = lazy(() => import('./components/Reports/TimeSheets'));
const TimeSheetHourly = lazy(() => import('./components/Reports/TimeSheets/Hourly'));
const JobDetailPage = lazy(() =>
  import('./components/Job/coder').then((module) => ({ default: module['JobDetailPage'] }))
);
const CoderProposalPreview = lazy(() =>
  import('./components/Job/coder').then((module) => ({ default: module['CoderProposalPreview'] }))
);
const FilterCoder = lazy(() => import('./components/ClientDashboard/components/FilterCoder'));
const JobDetailTimeSheet = lazy(
  () => import('./components/Job/coder/JobDetailsPage/JobDetailTimeSheet')
);
const InviteCoder = lazy(() => import('./components/ClientDashboard/components/InviteCoder'));
const Register = lazy(() => import('./components/Register'));
const TermsConditionHelper = lazy(() => import('./components/TermsConditions/TermsConditions'));
const Verification = lazy(() => import('./components/Register/Verification'));
const VerificationConfirm = lazy(() => import('./components/Register/Verification/Confirm'));
const CometChatUIComponent = lazy(() => import('./cometchat/CometChatUI'));
const MainLayoutComponent = lazy(() => import('./components/Layout/MainLayout'));
const LoginComponent = lazy(() => import('./components/Login'));
const InfoStepper = lazy(() => import('./components/InfoStepper'));
// import HomeLayout from './views/HomePageLayout';
interface roleBaseInterfce {
  roles: Array<string>;
}

// roles variables we need to move .env file
const ROLE_CLIENT = 'CLIENT';
const ROLE_CODER = 'CODER';
const ROLE_ADMIN = 'ADMIN';
const ROLE_SUPER_ADMIN = 'SUPER-ADMIN';
const ROLE_SUCCESS_MANAGER = 'SUCCESS-MANAGER';
// Procted route with token
const ProtectedRoute = () => {
  const token = localStorage.getItem('token') || Cookies.get('access_token');
  return !token ? <Navigate to="/login" /> : <Outlet />;
};

// Procted route with role
const RoleBaseRoute = ({ roles }: roleBaseInterfce) => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(true);
  const encryptedRole = localStorage.getItem('role') || Cookies.get('role');
  const role = decryptedData(encryptedRole);
  const newRole = role ? role : '';
  const titleRole = `You are logged in as  ${newRole.toLowerCase()}`;
  const webistUrl = process.env.REACT_APP_WEBSITE_BASE_URL;
  const handlLogoutButton = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (webistUrl) window.location.href = webistUrl;
    else window.location.href = 'https://hirecoder.ai/';
    localStorage.clear();
  };
  return roles.includes(newRole) ? (
    <Outlet />
  ) : (
    <div>
      <Modal
        open={isModalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        closeIcon={true}
        title={titleRole}
        modalBodyWidth="380px"
        closeIconCustomWidth="success-manager-close-icon">
        <Box display={'flex'} justifyContent={'space-between'}>
          <Box>Please login as a {role === ROLE_CLIENT ? 'coder' : 'client'}</Box>
          <Button variant="contained" onClick={(e) => handlLogoutButton(e)}>
            Logout
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

const AppRoutes = ({ headerProps }: any) => {
  return (
    <Routes>
      {/* do not remove this path HomeLayout for responsive  */}
      {/* <Route path="/" element={<HomeLayout />} /> */}
      {/* <Route path="/" element={<ClientHomePage />} />
      <Route path="/jobs" element={<CoderHomePage />} />
      <Route path="/our-team" element={<OurTeamPage />} />
      <Route path="/contact-us" element={<ContactUsPage />} />
      <Route path="/consult-us" element={<ConsultUspage />} />
      <Route path="/careers" element={<CareerHomePage />} />
      <Route path="/testimonial" element={<TestimonialPage />} />
      <Route path="/faqs" element={<FAQPage />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditionPage />} />
      <Route path="/privacy-policy" element={<PolicyHomePage />} />
      <Route path="/tax-initial-fee" element={<TexAndInitialFeePage />} /> */}
      <Route path="*" element={<PageNotFound />} />
      <Route
        element={
          <Suspense fallback={<SpinnerLoader />}>
            <MainLayoutComponent {...headerProps} />
          </Suspense>
        }>
        <Route
          path="/terms-and-conditions"
          element={
            <LazyLoad>
              <TermsAndConditionPage />
            </LazyLoad>
          }
        />
        <Route element={<ProtectedRoute />}>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route path="/clientDashboard" element={<ClientDashboardPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route path="/coder/dashboard" element={<CoderDashboardPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/coder/:coderId/proposal?/:id?/jobId?/:jobId?"
              element={
                <LazyLoad>
                  <CoderProfileDetails />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route
              path="/coderList"
              element={
                <LazyLoad>
                  <CoderList />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/client/job-post"
              element={
                <LazyLoad>
                  <ClientJobDetail />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/client/job/:id/detail"
              element={
                <LazyLoad>
                  <JobDetails />
                </LazyLoad>
              }
            />
            <Route
              path="/pay-now"
              element={
                <LazyLoad>
                  <PayNow />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route
              path="/coder/:id/details"
              element={
                <LazyLoad>
                  <CoderDetails />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route path="/coders/profile" element={<CoderProfilePage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/client/profile"
              element={
                <LazyLoad>
                  <ClientProfile />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/jobPost"
              element={
                <LazyLoad>
                  <ClientJobDetail />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route
              path="/coders/profile"
              element={
                <LazyLoad>
                  <CoderProfile />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/client/profile"
              element={
                <LazyLoad>
                  <ClientProfile />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/reports"
              element={
                <LazyLoad>
                  <TransactionHistory />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/reports/timesheets/fixedPrice"
              element={
                <LazyLoad>
                  <TimeSheet />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/reports/timesheets/hourly"
              element={
                <LazyLoad>
                  <TimeSheetHourly />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/job/:id/details"
              element={
                <LazyLoad>
                  <JobDetailPage />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/jobs/:id/proposals"
              element={
                <LazyLoad>
                  <ClientProposalListPage />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/reports/timesheets/fixedPrice"
              element={
                <LazyLoad>
                  <TimeSheet />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/jobs/:id"
              element={
                <LazyLoad>
                  <JobDetailPage />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route path="/jobs/:id/proposal" element={<CoderApplyProposalPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route
              path="/jobs/:id/proposalPreview"
              element={
                <LazyLoad>
                  <CoderProposalPreview />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route path="/jobs/:id/proposals/:proposalId" element={<ClientViewProposalPage />} />
          </Route>
          <Route
            path="*"
            element={
              <LazyLoad>
                <PageNotFound />
              </LazyLoad>
            }
          />
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/jobs/awarded"
              element={
                <LazyLoad>
                  <JobAwarded />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/coder/search"
              element={
                <LazyLoad>
                  <FilterCoder />
                </LazyLoad>
              }
            />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route
              path="/jobs/:id/timesheet"
              element={
                <LazyLoad>
                  <JobDetailTimeSheet />
                </LazyLoad>
              }
            />
          </Route>

          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT]} />}>
            <Route
              path="/jobs/:id/invite"
              element={
                <LazyLoad>
                  <InviteCoder />
                </LazyLoad>
              }
            />
          </Route>
          <Route
            element={
              <RoleBaseRoute roles={[ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_SUCCESS_MANAGER]} />
            }>
            <Route path="/admin/dashboard" element={<AdminManagePage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_ADMIN, ROLE_SUPER_ADMIN]} />}>
            <Route path="/job/details/:id" element={<AdminJobPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_ADMIN, ROLE_SUPER_ADMIN]} />}>
            <Route path="/dispute/details/:id" element={<AdminDisputePage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_SUCCESS_MANAGER]} />}>
            <Route path="/success-manager/dashboard" element={<SuccessManagerPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route path="/all/jobs" element={<AllJobsPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CODER]} />}>
            <Route path="/recommended-jobs" element={<RecommendedJobsPage />} />
          </Route>
          <Route element={<RoleBaseRoute roles={[ROLE_CLIENT, ROLE_CODER]} />}>
            <Route
              path="/chats"
              element={
                <Suspense fallback={<SpinnerLoader />}>
                  <CometChatUIComponent />
                </Suspense>
              }
            />
          </Route>
        </Route>
      </Route>
      <Route element={<AuthLayout />}>
        <Route
          path="/stepper"
          element={
            <LazyLoad>
              <InfoStepper />
            </LazyLoad>
          }
        />
        <Route
          path="/verification"
          element={
            <LazyLoad>
              <Verification />
            </LazyLoad>
          }
        />
        <Route
          path="/password-change/confirm"
          element={
            <LazyLoad>
              <SuccessPage />
            </LazyLoad>
          }
        />
        <Route
          path="/verification/confirm"
          element={
            <LazyLoad>
              <VerificationConfirm />
            </LazyLoad>
          }
        />
        <Route
          path="/register/client"
          element={
            <LazyLoad>
              <ClientRegistration />
            </LazyLoad>
          }
        />
        <Route
          path="/register/coder"
          element={
            <LazyLoad>
              <CoderRegistration />
            </LazyLoad>
          }
        />
        <Route
          path="/login"
          element={
            <Suspense fallback={<SpinnerLoader />}>
              <LoginComponent />
            </Suspense>
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/password-reset-confirm" element={<PasswordReset />} />
        <Route path="/password-change" element={<SetNewPassword />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
